module.exports = __webpack_public_path__ + "img/WePayLogo.ac49e823.png";